import { render } from "./TemplateList.vue?vue&type=template&id=361b1714&scoped=true"
import script from "./TemplateList.vue?vue&type=script&lang=js"
export * from "./TemplateList.vue?vue&type=script&lang=js"

import "./TemplateList.vue?vue&type=style&index=0&id=361b1714&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-361b1714"]])

export default __exports__